import SingleModelInterface from '../../types/singleModelInterface'
import Option from './Option'
import getOptions from './getOptions'

export default function getCarModelOptions(
    models: SingleModelInterface[]
): Option {
    if (typeof models === 'undefined') {
        return {}
    }

    const carModel = models.map((model) => model.carline_name)

    return getOptions(carModel)
}
